__turbopack_context__.v({
  "learn-hero-carousel-card": "_4tRRza_learn-hero-carousel-card",
  "learn-hero-carousel-card__actions": "_4tRRza_learn-hero-carousel-card__actions",
  "learn-hero-carousel-card__authors": "_4tRRza_learn-hero-carousel-card__authors",
  "learn-hero-carousel-card__content": "_4tRRza_learn-hero-carousel-card__content",
  "learn-hero-carousel-card__description": "_4tRRza_learn-hero-carousel-card__description",
  "learn-hero-carousel-card__first-author": "_4tRRza_learn-hero-carousel-card__first-author",
  "learn-hero-carousel-card__image": "_4tRRza_learn-hero-carousel-card__image",
  "learn-hero-carousel-card__info": "_4tRRza_learn-hero-carousel-card__info",
  "learn-hero-carousel-card__other-authors": "_4tRRza_learn-hero-carousel-card__other-authors",
  "learn-hero-carousel-card__read-time": "_4tRRza_learn-hero-carousel-card__read-time",
  "learn-hero-carousel-card__read-time--with-separator": "_4tRRza_learn-hero-carousel-card__read-time--with-separator",
  "learn-hero-carousel-card__title": "_4tRRza_learn-hero-carousel-card__title",
});
